import { render } from "./BucketLists.vue?vue&type=template&id=3340a6a1"
import script from "./BucketLists.vue?vue&type=script&lang=js"
export * from "./BucketLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__